// extracted by mini-css-extract-plugin
export default {"logoutComponent":"_3nzzAx","horizontalLine":"_17VoPS","textWrap":"_1ISkOW"};